var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25.541 25.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_523",
    "data-name": "\\u7EC4 523",
    transform: "translate(-139.754 -3387.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_251",
    "data-name": "\\u8DEF\\u5F84 251",
    d: "M154.02,3387.86H163.4a.376.376,0,0,0,.067.031,2.129,2.129,0,0,1,1.828,2.229q0,4.3,0,8.6a2.732,2.732,0,0,1-.8,1.98q-5.994,6.011-12.01,12a2.483,2.483,0,0,1-.867.558,2.1,2.1,0,0,1-2.334-.608q-4.256-4.258-8.517-8.511a3.1,3.1,0,0,1-1.005-1.615v-.549a3.063,3.063,0,0,1,1-1.62q5.8-5.785,11.6-11.58a4.606,4.606,0,0,1,.973-.672A3.894,3.894,0,0,1,154.02,3387.86Zm7.015,6.384a2.128,2.128,0,1,0-2.126,2.127A2.145,2.145,0,0,0,161.035,3394.244Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingFilled);
export default __webpack_public_path__ + "static/media/pricing_filled.66a3ab5e.svg";
export { ForwardRef as ReactComponent };